import { NavigationGuardNext, RouteLocationNormalized, Router } from 'vue-router';
import store from '../../store';
import { RedirectDuringLoad } from '../../store/fetch';

async function loadGuard(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void> {
  try {
    for (const record of to.matched) {
      const actions = record.meta.load;
      // we intentionally wait for all loaders of one route record to complete before proceeding
      // to the next because child loaders may depend on the result of parent loaders
      // eslint-disable-next-line no-await-in-loop
      await store.dispatch('fetch/load', {
        actions,
        params: {
          ...to.query,
          ...to.params,
        },
      });
    }
    next();
  } catch (error: any) {
    if (error instanceof RedirectDuringLoad) {
      error.handle(to, from, next);
    } else {
      next(error);
    }
  }
}

function unloadHook(to: RouteLocationNormalized, from: RouteLocationNormalized): void {
  const inactivatedRecords = from.matched.filter(record => !to.matched.includes(record));
  const mutations = inactivatedRecords.flatMap(record => record.meta.unload || []);
  store.dispatch('fetch/unload', [mutations, to]).catch(console.error); // eslint-disable-line no-console
}

export default function setupFetchGuard(router: Router): void {
  router.beforeEach(loadGuard);
  router.afterEach(unloadHook);
}
